import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  constructor() { }
  
  getCurrentDate(): string {
    return new Date().toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
  }
}